module.exports = __webpack_public_path__ + "img/matisa-logo_lime.cf5802f8.png";